/**
 * Workbench link building (TASK-785).
 *
 * The workbenches read the task scope EXCLUSIVELY from the `?task=` search param
 * (`WordWorkbench` → `useTaskScope`, and `WorkbenchRail` derives `originTaskId`
 * from it). A surface that knows its task and drops the param opens a document
 * with an empty rail — no origin thread, no resumed conversation — and the loss
 * is silent. One place builds the param so every opener carries it the same way.
 */

/** Append the task scope to an already-resolved workbench route. */
export function withTaskScope(route: string, taskId?: string | null): string {
  return taskId ? `${route}?task=${taskId}` : route;
}

/** The route that opens a workbench document, scoped to its task when there is one. */
export function workbenchRoute(documentId: string, taskId?: string | null): string {
  return withTaskScope(`/workbench/${documentId}`, taskId);
}
